import {Component, OnInit} from '@angular/core';
import {PaginationInstance} from 'ngx-pagination';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {DonarListService} from './donar-list.service';


@Component({
    selector: 'app-donar-list',
    templateUrl: './donar-list.component.html',
    styleUrls: ['./donar-list.component.css']
})
export class DonarListComponent implements OnInit {
    display:boolean=false;
    formData: any = {}; // Object to store form data
    ind:any;

    public config: PaginationInstance = {
        id: 'advanced',
        itemsPerPage: 10,
        currentPage: 1,
        totalItems: 1
    };
    loading: boolean;
    DonerList: any;
    AddForm: FormGroup;
    constructor(private formBuilder: FormBuilder,private donarListService:DonarListService) {
    }

    ngOnInit() {
        this.getPage(1);
        this.AddForm = this.formBuilder.group({
            donerName: ['', Validators.required],
            gender: ['', Validators.required],
            bloodGroup: ['', Validators.required],
            address: ['', Validators.required],
            mobile: ['', Validators.required],
            email: ['', Validators.required],
            lastDonated: ['', Validators.required] // Assuming this is for last blood donation
        });
    }
    donordialog(){
        this.display=true;
    }

    cancelForm(){

    }




    getPage(page: number) {
        if (page > 1) {
            this.ind = ((page - 1) * this.config.itemsPerPage) + 1;
        }else {
            this.ind = 1;
        }
        this.loading = true;
        this.donarListService.findAllRecordService().then(resp => {this.DonerList = resp;});

    }


    openDialog() {
        this.display = true;
    }

    saveForm() {
        if (this.validateForm()) {
            // Call the service method to save the data
            this.donarListService.addRecordService(this.AddForm.value).then(
                response => {
                    console.log('Data saved successfully:', response);
                    this.clearForm();
                    this.closeDialog();
                },
                error => {
                    console.error('Error saving data:', error);
                    // Handle error if needed
                }
            );
        } else {
            alert('Please fill in all required fields.');
        }
    }

    cancel() {
        this.clearForm();
        this.closeDialog();
    }

    clearForm() {
        this.formData = {}; // Reset form data
    }

    closeDialog() {
        this.display = false; // Close the dialog
    }

    validateForm(): boolean {
        // Implement your form validation logic here
        return true; // Change this based on your validation logic
    }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/blood-transfusion/donar-list/donar-list.component.ts